// @flow

// Returns last element of an array
export const last = (arr: Array<*>): * => arr[arr.length - 1];

// Checks if item is in array
export const isInArray = <A>(x: A) => (xs: Array<A>): boolean => xs.includes(x);



// WEBPACK FOOTER //
// ./src/helpers/arrays.js